module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_vm._m(0), (_vm.lista.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1)]) : _vm._e(), _c('div', {
    ref: "courses",
    staticClass: "courses",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.lista), function(curso) {
    return _c('div', {
      key: curso.id,
      staticClass: "course"
    }, [_c('div', {
      staticClass: "course-heading"
    }, [_c('div', {
      staticClass: "course-main"
    }, [_c('strong', [_vm._v(_vm._s(curso.titulo))]), _c('div', {
      staticClass: "course-meta"
    }, [_c('span', [_vm._v(_vm._s(curso.NumeroClases) + " clase(s)")]), _c('span', {
      staticClass: "separator"
    }, [_vm._v("•")]), _c('span', [_vm._v(_vm._s(curso.DuracionTotal))])])]), _c('span', {
      staticClass: "status",
      class: {
        completed: curso.progreso === 100
      }
    }, [_vm._v(_vm._s(curso.progreso === 100 ? 'Completado' : 'Pendiente'))])]), _c('div', {
      staticClass: "progress-header"
    }, [_c('span', [_vm._v("Progreso")]), _c('strong', [_vm._v(_vm._s(curso.progreso) + "%")])]), _c('div', {
      staticClass: "progress-bar"
    }, [_c('div', {
      staticClass: "progress-value",
      style: ({
        width: curso.progreso + '%'
      })
    })]), _c('button', {
      staticClass: "course-action",
      on: {
        "click": function($event) {
          return _vm.continuar(curso.id)
        }
      }
    }, [_vm._v(_vm._s(curso.progreso > 0 ? 'Continuar curso' : 'Comenzar curso')), _c('span', [_vm._v("→")])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Mis cursos")]), _c('p', [_vm._v("Capacitaciones y cursos asignados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-info"
  }, [_c('strong', [_vm._v("No tienes Cursos Asignados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca15d9fe","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_mis_cursos.vue
// module id = 955
// module chunks = 0